export default "__VITE_ASSET__C03xZxX1__"